import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import classNames from 'classnames/bind';
import RestorePhoneNumber from './RestorePhoneNumber';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { getLuxeFlags } from '../../../Flags/selectors';
import { getStreetFlags } from '../../../refresh/selectors/featureFlagsSelector';
import { STREET_STORE } from '../../../constants/constant';
import Logo from '../../../components/desktop/header/Logo';
import { RESTORE_PHONENUMBER } from './constants';
import { useHistory } from 'react-router-dom';
import {
  generateCaptchaForRestoreMobile,
  generateEmailForRestoreMobile
} from '../../actions/signinAction';
import SuccessVerification from './SuccessVerification';
import { tokenReCreateParser } from '../../../modules/ajio-fetch/utils';
import { createCookie } from '../../../utils/Cookie';
import Loader from '../../../components/common/Loader';
import styles from './index.pcss';

const cx = classNames.bind(styles);

const FraudFlowWrapper = props => {
  const { token = '' } = useParams();
  const [showVerifyEmail, setShowVerifyEmail] = useState(false);
  const {
    refreshCaptcha,
    signInReducer,
    generateCaptchaForRestoreMobile,
    generateEmailForRestoreMobile
  } = props;
  const history = useHistory();
  const pathname = history?.location?.pathname;
  const { metaData: { sis = false } = {}, newDesignLuxe, isStreet } = props;
  const [captchaRes, setCaptchaRes] = useState();
  useEffect(() => {
    generateCaptchaForRestoreMobile(() => {});
  }, []);
  return (
    <div className={cx('fraud_container')}>
      <Loader name="auth-modal-loader" />
      <div className={cx('fraud_header')}>
        <Logo sis={sis} newDesignLuxe={newDesignLuxe} isStreetStore={isStreet} />
      </div>
      <div className={cx('modal_container')}>
        <div className={cx('fraud_form-container')}>
          <div className={cx('fraud_form')}>
            {pathname === RESTORE_PHONENUMBER && !showVerifyEmail ? (
              <RestorePhoneNumber
                refreshCaptcha={refreshCaptcha}
                signInReducer={signInReducer}
                setShowVerifyEmail={setShowVerifyEmail}
                generateCaptchaForRestoreMobile={generateCaptchaForRestoreMobile}
              />
            ) : (
              <SuccessVerification />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { metaData, flags } = state;
  const { signInReducer } = state;

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const { isThemeEnableWeb } = getStreetFlags(state);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  return {
    newDesignLuxe,
    metaData,
    isStreet: isThemeEnableWeb === 'ON' && storeName === STREET_STORE,
    signInReducer
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    refreshCaptcha: (data, callback) => {
      dispatch(refreshCaptcha(data, callback));
    },
    generateCaptchaForRestoreMobile: callback => {
      dispatch(generateCaptchaForRestoreMobile(callback));
    },
    generateEmailForRestoreMobile: (data, callback) => {
      dispatch(generateEmailForRestoreMobile(data, callback));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FraudFlowWrapper);
